import React from "react";
import { Box } from "@mui/material";
import { Controller, Control } from "react-hook-form";
import { css, Theme } from "@theme";
import { FormFields, NOTE_TEMPLATES } from "./PatientNotesConstants";
import { PatientNotesTemplateSelect } from "./PatientNotesTemplateSelect";
import { PatientNotesNoteTitleRow } from "./PatientNotesNoteTitleRow";
import { PatientNotesTextArea } from "./PatientNotesTextArea";

interface PatientNotesFormPaneProps {
  control: Control<FormFields>;
  isLoading: boolean;
  isGenerating: boolean;
  onTemplateSelect: (template: typeof NOTE_TEMPLATES[number] | null) => void;
  isExpanded?: boolean;
}

const styles = {
  container: (theme: Theme) => css`
    position: relative;
    background-color: ${theme.palette.common.white};
    height: 100%;
    display: flex;
    flex-direction: column;
  `,
};

export const PatientNotesFormPane: React.FC<PatientNotesFormPaneProps> = ({
  control,
  isLoading,
  isGenerating,
  onTemplateSelect,
  isExpanded,
}) => {
  return (
    <Box css={styles.container}>
      <Controller
        control={control}
        name="template"
        render={({
          field: { value, onChange },
          fieldState: { error },
        }) => (
          <PatientNotesTemplateSelect
            value={value}
            onChange={onChange}
            onTemplateSelect={onTemplateSelect}
            error={error}
            disabled={isLoading || isGenerating}
          />
        )}
      />

      <Controller
        control={control}
        name="title"
        render={({
          field: { value, onChange },
          fieldState: { error },
        }) => (
          <PatientNotesNoteTitleRow
            value={value}
            onChange={onChange}
            error={error}
            disabled={isLoading || isGenerating}
          />
        )}
      />

      <Controller
        control={control}
        name="text"
        render={({
          field: { value, onChange },
          fieldState: { error },
        }) => (
          <PatientNotesTextArea
            value={value}
            onChange={onChange}
            error={error}
            disabled={isLoading || isGenerating}
            isExpanded={isExpanded}
          />
        )}
      />
    </Box>
  );
};

